jQuery(function ($) {
  $( document ).ready(function() {
      $('.tooltip').tooltipster({
          animation: 'fade',
          theme: 'tooltipster-shadow',
          trigger: 'click',
          interactive: true,
          maxWidth: 500
      });
  });
});